import {filter, map} from 'rxjs/operators';
import {uiMsg$, toUiMsg$} from '@/ui';
import {WsSubscribe} from './sub';
import type {AuctionProjectPoolInfo} from './AuctionData';
import {auctionProjectPoolInfo$} from './AuctionData';

export interface FUAuctionSubscribe {
  type: 'auction-subscribe';
}

export interface FUAuctionUnsubscribe {
  type: 'auction-unsubscribe';
}

export interface UAuctionProjectPoolInfo {
  type: 'auction-project-pool-info';
  data: AuctionProjectPoolInfo;
}

const ws = new WsSubscribe();

const sub$ = uiMsg$.pipe(filter((o) => o.type === 'auction-subscribe'));
const unSub$ = uiMsg$.pipe(filter((o) => o.type === 'auction-unsubscribe'));

export function subscribeBusinessDutchAuction() {
  sub$.subscribe(() => ws.subscribe());
  unSub$.subscribe(() => ws.unsubscribe());

  auctionProjectPoolInfo$
    .pipe(
      map(
        (data: AuctionProjectPoolInfo): UAuctionProjectPoolInfo => ({
          type: 'auction-project-pool-info',
          data,
        })
      )
    )
    .subscribe((msg) => toUiMsg$.next(msg));
}
